module.exports = __webpack_public_path__ + "img/but-bottom.c23cd5fd.png";